// Bölüm 1: kayıtlı alanı düzenleme (kırmızı çerçeve, X ile geri al, değişince Kaydet zorunlu) ve belge etkisi uyarısı
import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { X, Check } from 'lucide-react';
import { Button } from '../../ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../ui/alert-dialog';

const EDIT_FIELDS = { start: ['start_date', 'start_time'], end: ['end_date', 'end_time'], details: ['job_description'] };
const SNAP_FIELDS = ['start_date', 'start_time', 'end_date', 'end_time', 'job_description'];

export const useFieldEdit = (formData, setFormData, savedFlags) => {
  const [edit, setEdit] = useState(null);
  const dirty = !!edit && EDIT_FIELDS[edit.key].some(f => (formData[f] || '') !== (edit.snap[f] || ''));
  const begin = (key) => {
    if (edit?.key === key || !savedFlags[key]) return;
    if (dirty) { toast.warning('Önce yaptığınız değişikliği kaydedin veya X ile geri alın'); return; }
    setEdit({ key, snap: Object.fromEntries(SNAP_FIELDS.map(f => [f, formData[f]])) });
  };
  const cancel = () => { setFormData(prev => ({ ...prev, ...edit.snap })); setEdit(null); };
  const save = () => setEdit(null);
  return { editKey: edit?.key, dirty, begin, cancel, save };
};

export const EditControls = ({ fieldKey, edit, testId }) => {
  if (edit.editKey !== fieldKey) return null;
  return (
    <div className="flex items-center gap-2">
      {edit.dirty && (
        <Button type="button" size="sm" onClick={edit.save} className="h-10 px-4 bg-rose-600 hover:bg-rose-700 text-white" data-testid={`${testId}-edit-save`}>
          <Check className="h-4 w-4 mr-1" />Kaydet
        </Button>
      )}
      <Button type="button" size="icon" variant="outline" onClick={edit.cancel} title={edit.dirty ? 'Değişikliği geri al' : 'Kapat'} className="h-10 w-10 border-rose-300 text-rose-600 hover:bg-rose-50" data-testid={`${testId}-edit-cancel`}>
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

// Gönderilmiş talepte lokasyon / iş tipi / iş çeşidi değişince belgeler etkilenebilir: önce onay alınır
export const useDocChangeConfirm = (enabled) => {
  const [pending, setPending] = useState(null);
  const ack = useRef(false);
  const guard = (apply) => {
    if (!enabled || ack.current) { apply(); return; }
    setPending(() => apply);
  };
  const dialog = (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
      <AlertDialogContent data-testid="doc-change-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-amber-700">Belgeleriniz etkilenebilir</AlertDialogTitle>
          <AlertDialogDescription>
            Lokasyon, İş Tipi veya İş Çeşidi değiştiğinde istenen belgeler artabilir veya azalabilir. Bu değişiklik tüm talebi tekrar onaya düşürebilir veya onaylı belgeleriniz tekrar "Onay Bekliyor" olarak değişebilir. Devam etmek istiyor musunuz?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="doc-change-cancel">Vazgeç</AlertDialogCancel>
          <AlertDialogAction className="bg-amber-600 hover:bg-amber-700" onClick={() => { ack.current = true; pending?.(); setPending(null); }} data-testid="doc-change-ok">Devam Et</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return { guard, dialog };
};
